import { client } from '@hotjar/api-base-client';
import { getCurrentUserOwnedAccountId } from '@hotjar/user';
import { queryClient } from '../../queries';
import type { LegacyAccountInvoicesModel } from './invoices-types';

interface GetOldInvoices {
  accountId: number;
}

export async function getOldInvoices({
  accountId,
}: GetOldInvoices): Promise<LegacyAccountInvoicesModel> {
  const data = await client<LegacyAccountInvoicesModel, LegacyAccountInvoicesModel>({
    url: `/api/v1/accounts/${accountId}/invoices`,
  });

  return data;
}

export function getOldInvoicesQuery({
  accountId,
}: GetOldInvoices): Promise<LegacyAccountInvoicesModel> {
  return queryClient.fetchQuery({
    queryFn: () => getOldInvoices({ accountId }),
  });
}

export async function getCustomerAndOldInvoices(): Promise<LegacyAccountInvoicesModel> {
  const accountId = await getCurrentUserOwnedAccountId();

  if (accountId !== undefined) {
    const invoices = await getOldInvoicesQuery({ accountId });
    return invoices;
  }

  return [];
}
